import { SortingOptions } from '@components/design/migrated/Table/Sorting/types';
import React, { SetStateAction, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { RelativePeriod, RelativePeriodLabel } from '@components/comparison-period-selector/Types';
import ContextBar from '../../components/context-bar/ContextBar';
import { layouts } from '@ecosystem/newron-design-system';
import FilterChips from '../../components/filter-chips/FilterChips';
import FilterSelectionNote from '../../components/filter-selection-note/FilterSelectionNote';
import InfoModal from '../../components/info-modal/InfoModal';
import PageHeader from '../../components/page-header/PageHeader';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { BaseTimePeriod, FilterParam, MainFilters, TimePeriod } from '@services/FiltersTypes';
import { opportunityReviewResponseConfig } from '@utils/FilterSettings';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import {
  CountryFilterPair,
  FeatureOption,
  FilterKeys,
  Filters,
  Option,
  PageName,
  PageType,
  PageTypeAndName,
  SelectedPgCheckParam,
  ShareType,
} from '@utils/pageConfig/Types';
import PageInfo from '../info/PageInfo';

import { ExportFormat, FilterToggleButton, useAnalytics } from '@ecosystem/newron-client-lib';
import { cloneDeep } from 'lodash';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';
import { batch, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  handleStackedChartSegmentSelect,
  HandleStackedChartSegmentSelectParams,
  initialSegmentByValue,
} from '@components/chartpickers/SegmentByChartPickersUtil';
import ComparisonGrowthSelector from '../../components/comparison-growth-selector/ComparisonGrowthSelector';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import LoadingOverlay from '../../components/loading-overlay/LoadingOverlay';
import {
  constructCountryOption,
  getSelectedClientNameWithClientId,
  getSubscriptionForOtherProducts,
  mapDefaultSubscribedCountry,
  mapSubscribedCountries,
  onChangeHandlerForOtherProducts,
  OnRetailerChangeParam,
  saveErrorLogForOnChange,
} from '@components/multi-banner-retailer-selector/MultiBannerRetailerSelectorUtils';
import {
  ExportPerformanceBySegmentResp,
  PerformanceAnalysisboardParam,
  PerformanceAnalysisParam,
} from '@data-visualization/performance-analysis-line-chart/Types';
import { mapStackedChartKPI } from '@data-visualization/stacked-chart/StackedChart';
import { StackedChartResp } from '@data-visualization/stacked-chart/Types';
import { FilterCriteriaParam } from '@models/CommonParam';
import { ClientSubscription } from '@models/Opa';
import { WeeklyMonthlyFeatures } from '@models/OpportunityReview';
import {
  DefaultSortingOptionsForPerformanceAnalysisboard,
  getDisplayNameFromHeaderKey,
  kpiDropdownOptions,
  PageRequest,
  PerformanceAnalysisboardPg,
  PerformanceAnalysisboardPgPage,
  PerformanceAnalysisboardTableId,
} from '@models/PerformanceAnalysisboard';
import { RetailerClient } from '@models/RetailerClient';
import { getExportPerformanceAnalysisLineChart } from '@services/Chart.service';
import { getPerformanceAnalysisBoard, getStackedChart } from '@services/PerformanceAnalysisboard.service';
import {
  actionCreators,
  actionCreatorsHitlistsRetailerClient,
  actionCreatorsInitialFilters,
  actionCreatorsInitialFiltersMarketPremium,
  actionCreatorsInitialFiltersProducts,
  actionCreatorsMarketPremium,
  actionCreatorsMarketPremiumClientState,
  actionCreatorsProducts,
  actionCreatorsRetailerClient,
  actionCreatorsRO,
  actionCreatorsSideFilters,
} from '../../state/Index';
import { constructRetailerClientState } from '@state/reducers/retailer-client/RetailerClientUtils';
import {
  checkIfCountryExist,
  checkPGsByCountryPrecondition,
  checkSelectedPgExists,
  constructCountryFilter,
  constructCountryOptionForSideMenu,
  constructCurrencySideMenuFilterOptions,
  findDefaultFilterBySelectedCountries,
  getCountriesByAccessibleProductGroup,
  getFeatureValueBySubscription,
  getFiltersForClient,
  getFiltersInitialState,
  getInitialAppliedCountries,
  getInitialSelectedAddFeat,
  getInitialSelectedAddFeatValues,
  getInitialSelectedSegFeat,
  getInitialSelectedSegFeatValues,
  getPeriodForFeatures,
  getSelectedAddFeatValues,
  getSelectedSegFeatValues,
  getSubscriptionByCountryAndProductType,
  getSubscriptionPeriodicitiesByCountryAndProductType,
  isAllFeatureValuesEmpty,
  isAppliedFiltersEqualToSelectedFilters,
  isRemovePricebandFilterForNonLocalCurrency,
  isValidTimeFrameAndPeriod,
  removeUnsavedFilters,
  UpdateAddFeatSegFeatValues,
  updateAppliedCurrencyFilterByCountry,
  updatePgsByCountryOnCountryApplyWithProductType,
  updatePgsByCountryOnCountrySelectWithProductType,
  updateSelectedProductGroup,
  validateStoreFilterSettings,
} from '@utils/FilterUtils';
import {
  checkPeriodExist,
  convertYTDOrMATtoPeriodType,
  getDefaultMonthlyPeriodForPALineChart,
  getDefaultValueForDerivablePeriodicity,
  getMainFiltersList,
  getPeriodicityForMATAndYTD,
  getPeriodMeta,
  isBaseTimePeriodFormat,
  updatePeriodFiltersWhenCountryChange,
} from '@utils/PeriodUtils';
import { isAuthorized } from '@utils/Permission';
import {
  buildOptions,
  constructFeatureValueParam,
  EMPTY_FEATURE_OPTION,
  getFeatureSelector,
} from '@utils/hook/selector/ShowPerformanceWithinSelector';
import { matchKPI, usePersistedSorting } from '@utils/hook/sorting/UsePersistedSorting';
import { ProductDataType, ProductType } from '../product-analyzer/Product';
import { Unauthorized } from '../unauthorized/Unauthorized';
import * as styles from './PerformanceAnalysis.module.scss';

import { useChartExport, useMultipleChartsExport } from '@ecosystem/export-utils';
import { SortFieldDisplayProps, SortingOptionsType } from '@components/design/migrated/Table';
import { displayExportErrorToastMessage, getAppliedFiltersText } from '@hooks/export/ExportUtils';
import { ExportLineChartOptions, useExportMultiChart } from '@hooks/export/utilities/UseExportMultiChart';
import { useExportStackedChart } from '@hooks/export/export-stacked-chart/UseExportStackedChart';
import { useExportTable } from '@hooks/export/export-table/UseExportTable';
import { getExportTrackingFormat } from '@hooks/export/export-tracking/ExportTracking';
import getComparisonPeriod from '@components/filter-selection-note/GetComparisonPeriod';
import { PerformanceAnalysisView, PerformanceAnalysisViewMapping } from '@components/performance-analysis-card/Types';
import PerformanceAnalysisCopyViewButton from '@components/performance-analysis-copy-button/PerformanceAnalysisCopyViewButton';
import TimeFramePickerWrapper from '@components/time-frame-picker/components/wrapper/TimeFramePickerWrapper';
import { applyTimeFramePicker } from '@components/time-frame-picker/utils/TimeFramePickerUtils';
import { useToastMessage } from '@components/toast-message/ToastMessage';
import { France } from '@const/Countries';
import {
  ColumnHeaderDisplayNameForCL,
  ColumnHeaderForCL,
  DefaultSortingOptionsForCategoryLeaderboard,
} from '@models/CategoryLeaderboard';
import { PerformanceAnalysisViewState } from '@models/SavedViews';
import { getEffectiveProductType } from '@models/SubscribedProductType';
import { IRootState } from '@state/reducers/Reducers';
import { SideFiltersState } from '@state/reducers/side-filters/SideFiltersReducer';
import { getAndStoreSavedFilters } from '@utils/AppSubscriptionUtils';
import { getCountryFilterPairsByTimeFrame } from '@utils/CountryUtils';
import { getChartSubtitles } from '@utils/KpiTitleUtils';
import saveErrorLog, { ErrorTagEnum } from '@utils/LogUtil';
import { PERFORMANCE_BY_SEGMENTS_TREND } from '@utils/StringConstants';
import { constructCurrencyLabel, getFactRevenue, isLocalCurrencyApplied } from '@utils/currencyUtils/CurrencyUtils';
import { ElementType, TrackingGeneralProp } from '@utils/page-analytics/model/AnalyticTrackingBasePropertiesObj';
import {
  dataExportedTrackingFunction,
  DataExportTrackingElementParam,
  useDataExportTracking,
} from '@utils/page-analytics/model/DataExportTracking';
import {
  PAGE_VIEW_TRACKING_TITLE,
  pageViewTrackingFunction,
  PageViewTrackingFunctionParam,
} from '@utils/page-analytics/model/PageViewedTracking';
import { PERFORMANCE_ANALYSIS_CARD_TITLE } from '../Utilities';
import { DEFAULT_VOLUME, getVolumeBasedOnPeriodType } from '@utils/factVolumeUtils/FactVolumeUtils';
import useDebouncedEffect from '@hooks/UseDebouncedEffect';
import { useUpdatePerfPeriodSet } from '@utils/period-set/UseUpdatePerfPeriodSet';
import { byCountry } from '@state/reducers/initial-filter/InitialFiltersPredicates';
import { useInitializedPeriodSet } from '@utils/period-set/UseInitializedPeriodSet';
import { MainFiltersState } from '@state/reducers/main-filter/MainFiltersReducer';
import { MainFilterStateProducts } from '@state/reducers/main-filter-products/MainFiltersProductsReducer';
import { performanceAnalysisConfiguration } from '../Configuration';
import { checkMATOrYTDPeriodicity } from '@components/time-frame-picker/components/wrapper/WrapperUtils';
import useStackedChartSorting from '@utils/hook/sorting/UseStackedChartSorting';
import WarningCurrencyContainer from '@components/containers/warning-currency/WarningCurrencyContainer';
import { byFilterKey } from '@utils/pageConfig/Predicates/SelectedFiltersPredicates';
import {
  checkIsMultiCountryClient,
  getLatestPeriodAmongAppliedCountries,
  getLatestPeriodByPeriodicityForSingleCountry,
  isSelectedPeriodExistInAllMultiCountries,
  multiCountryDisabledFilters,
} from '@utils/multiCountryUtils/MultiCountryUtils';
import PerformanceAnalysisCard from '@components/performance-analysis-card/PerformanceAnalysisCard';
import WarningFeatureValueContainer from '@components/containers/warning-feature-value/WarningFeatureValueContainer';
import CountryAvailabilityBanner from '@components/country-availability-banner/CountryAvailabilityBanner';
import { getProductGroupsMasterByCountry } from '@services/ProductGroup.service';
import { capitalizeFirstLetter } from '@utils/StringUtils';
import { useDispatchCountriesAvailability } from '@utils/hook/incrementalLoading/UseDispatchCountriesAvailability';
import { Country } from '@components/context-bar/Types';
import {
  getGrandTotalValue,
  modifiedPAORSegmentExportGrandTotalToCamelCaseTotalValue,
  modifiedPAStackChartGrandTotalToTotalValue,
  modifiedPATableDoubleBarChartGrandTotalToTotalValue,
} from '@utils/TotalUtils';
import { useUserPersistedFilters } from '@utils/hook/saveFilter/UseUserPersistedFilters';
import PgAvailabilityBanner from '@components/pg-availability-banner/PgAvailabilityBanner';
import {
  PgAvailabilityProps,
  useDispatchPgsAvailability,
} from '@utils/hook/incrementalLoading/UseDispatchPgsAvailability';
import { ViewType } from '@hooks/export/Model';
import { useExportImages } from '@hooks/export/UseExportChartImage';
import { ChartKeys } from '@const/ChartKeys';
import { generateUniqueChartKeys } from '@data-visualization/utilities/GenerateUniqueChartKeys';
import {
  processExploreMarketLineChartData,
  processExploreRetailerLineChartData,
} from '@data-visualization/utilities/line-chart/FormatLineChartData';
import {
  getSaleTypeFromSortingOption,
  transformShareTypeToRetailerKpiOption,
} from '@data-visualization/utilities/ChartUtils';
import { useFactRevenueBySelectedCurrency } from '@hooks/UseFactRevenueBySelectedCurrency';
import { setApiErrorState } from '@services/utils/ErrorHandlers';

interface Props {
  retailerClients: RetailerClient[];
}

const supportedPeriodicities: Periodicity[] = performanceAnalysisConfiguration.supportedPeriodicities;

const disabledPeriodicityLineChart: Periodicity[] = performanceAnalysisConfiguration.disabledPeriodicityOptions;

const PerformanceAnalysis: React.FC<Props> = ({ retailerClients }) => {
  const pagesConfig = usePageConfig();
  const { refetch } = useUserPersistedFilters();
  const { Page } = layouts;
  //To be removed once multi country is enabled for line chart and
  // stack bar chart and use back pagesConfig.isMultiCountryDropdown
  const isMultiCountry = useMemo((): boolean => {
    return checkIsMultiCountryClient(pagesConfig.clientId);
  }, [pagesConfig.clientId]);

  const { clearExportImage, exportImages } = useExportImages(PageType.EXPLORE);

  const isAuthorizedRIUser = isAuthorized(pagesConfig.clientSubscription);
  const isAuthorizedRetailKadUser = isAuthorized(pagesConfig.retailKadClientSubscription);
  const isAuthorizedUser = isAuthorizedRIUser || isAuthorizedRetailKadUser;
  const { track } = useAnalytics();

  const dispatch = useDispatch();
  const { updateMainFilters } = bindActionCreators(actionCreators, dispatch);
  const { updateHitlistsRetailerClient } = bindActionCreators(actionCreatorsHitlistsRetailerClient, dispatch);
  const { updateRetailerClient } = bindActionCreators(actionCreatorsRetailerClient, dispatch);
  const { updateSideFilters } = bindActionCreators(actionCreatorsSideFilters, dispatch);
  const { updateMainFiltersRO } = bindActionCreators(actionCreatorsRO, dispatch);
  const { updateInitialFilters } = bindActionCreators(actionCreatorsInitialFilters, dispatch);
  const { updateMainFiltersMarketPremium } = bindActionCreators(actionCreatorsMarketPremium, dispatch);
  const { updateInitialFiltersProducts } = bindActionCreators(actionCreatorsInitialFiltersProducts, dispatch);
  const { updateInitialFiltersMarketPremium } = bindActionCreators(actionCreatorsInitialFiltersMarketPremium, dispatch);
  const { updateMarketPremiumRetailerClient } = bindActionCreators(actionCreatorsMarketPremiumClientState, dispatch);
  const { updateMainFiltersProducts } = bindActionCreators(actionCreatorsProducts, dispatch);
  const subscribedProductTypes = useSelector(
    (state: IRootState) => state.subscribedProductTypes.subscribedProductTypes,
  );
  const effectiveProductType = getEffectiveProductType(subscribedProductTypes, PageName.PERFORMANCE_ANALYSIS);

  const mainFiltersState: MainFiltersState = useSelector((state: IRootState) => state.mainFilters);
  const sideFiltersState: SideFiltersState = useSelector((state: IRootState) => state.sideFilters);
  const retailerClientState = useSelector((state: IRootState) => state.retailerClient);
  const mainFilterStateProducts: MainFilterStateProducts = useSelector(
    (state: IRootState) => state.mainFiltersProducts,
  );
  const initialFiltersState = useSelector((state: IRootState) => state.initialFilters);
  const initialFiltersProductsState = useSelector((state: IRootState) => state.initialFiltersProducts);
  const hitlistsRetailerClientState = useSelector((state: IRootState) => state.hitlistsRetailerClient);

  const CURRENT_TOTAL_NAME = getGrandTotalValue();
  const updatedInitialFiltersState = useMemo(
    () => ({
      ...initialFiltersState,
      initialFilters: initialFiltersState.initialFilters.map(
        (filter: { timePeriod: TimePeriod; timePeriodV2: TimePeriod }) => ({
          ...filter,
          timePeriod: filter.timePeriod,
        }),
      ),
    }),
    [initialFiltersState],
  );

  const [defaultFilters, setDefaultFilters] = useState<MainFilters[]>(updatedInitialFiltersState.initialFilters);

  const [filters, setFilters] = useState<MainFilters>(
    findDefaultFilterBySelectedCountries(
      pagesConfig.appliedFilters[PageType.PERFORMANCE_ANALYSIS].selectedFilters,
      defaultFilters,
    ),
  );

  const [allFeatureValuesForPA, setAllFeatureValues] = useState<Filters[]>([]);
  const [showPerformanceFeatureList, setShowPerformanceFeatureList] = useState<Filters[]>(
    cloneDeep(allFeatureValuesForPA),
  );

  const allFiltersForPA = useMemo(() => {
    return pagesConfig.appliedFilters[PageType.PERFORMANCE_ANALYSIS].selectedFilters;
  }, [pagesConfig.appliedFilters]);

  const pgInitialStateForPer = getFiltersInitialState(allFiltersForPA, FilterKeys.PRODUCT_GROUP);
  const addFeatInitialStateForPer = getFiltersInitialState(allFiltersForPA, FilterKeys.ADDFEAT);
  const segFeatInitialStateForPer = getFiltersInitialState(allFiltersForPA, FilterKeys.SEGFEAT);

  // Stores the selected product group
  const [selectedProductGroupOptions, setSelectedProductGroupOptions] = useState<Option[] | undefined>(
    pgInitialStateForPer !== undefined ? pgInitialStateForPer.options : undefined,
  );

  // Stores the applied product group. APIs use this state as query param
  const [appliedProductGroupOptions, setAppliedProductGroupOptions] = useState<Option[] | undefined>(
    pgInitialStateForPer !== undefined ? pgInitialStateForPer.options : undefined,
  );

  const [showPgModal, setShowPgModal] = useState<boolean>(false);

  const [feature, setFeature] = useState<FeatureOption>(mainFiltersState.feature);
  const [segmentByFeature, setSegmentByFeature] = useState<FeatureOption>(initialSegmentByValue);

  const [periodDisabled, setPeriodDisabled] = useState<boolean>(false);

  const [appliedCountries, setAppliedCountries] = useState<Option[]>(() =>
    getInitialAppliedCountries(pagesConfig, PageType.PERFORMANCE_ANALYSIS, effectiveProductType),
  );

  const [selectedCountries, setSelectedCountries] = useState<Option[]>(() =>
    getInitialAppliedCountries(pagesConfig, PageType.PERFORMANCE_ANALYSIS, effectiveProductType),
  );

  //region variables and setters related to period set
  const periodDispatchActions = useUpdatePerfPeriodSet();

  const timePeriodOptions: TimePeriod = useMemo(() => {
    return isMultiCountry && appliedCountries.length > 1
      ? getLatestPeriodAmongAppliedCountries(appliedCountries, updatedInitialFiltersState)
      : updatedInitialFiltersState.initialFilters.filter(byCountry(appliedCountries[0].value))[0].timePeriod;
  }, [appliedCountries, initialFiltersState, isMultiCountry]);

  const { period, periodicity, comparisonPeriod, customMonthsPeriodState } = useInitializedPeriodSet(timePeriodOptions);
  //endregion

  const [selectedGrowthType, setGrowthOption] = useState<GrowthTypes>(mainFiltersState.selectedGrowthType);

  const [selectedAddFeatPer, setSelectedAddFeatOpp] = useState<string | undefined>(
    getInitialSelectedAddFeat(addFeatInitialStateForPer),
  );

  const [selectedAddFeatPerValues, setSelectedAddFeatOppValues] = useState<Option[] | undefined>(
    getInitialSelectedAddFeatValues(addFeatInitialStateForPer),
  );

  const [selectedSegFeatPer, setSelectedSegFeatOpp] = useState<string | undefined>(
    getInitialSelectedSegFeat(segFeatInitialStateForPer),
  );

  const [selectedSegFeatPerValues, setSelectedSegFeatOppValues] = useState<Option[] | undefined>(
    getInitialSelectedSegFeatValues(segFeatInitialStateForPer),
  );
  const [pgsByAppliedCountries, setPgsByAppliedCountries] = useState<CountryFilterPair[]>([]);

  // includes weekly and monthly features
  const [weeklyMonthlyFeatures, setWeeklyMonthlyFeatures] = useState<WeeklyMonthlyFeatures>();
  const [performanceAnalysisParam, setPerformanceAnalysisParam] = useState<PerformanceAnalysisParam>();

  const [performanceAnalysisboardParam, setPerformanceAnalysisboardParam] = useState<PerformanceAnalysisboardParam>();
  const [loadingStackedChart, setLoadingStackedChart] = useState<boolean>(false);

  const { sorting } = usePersistedSorting({
    tableId: PerformanceAnalysisboardTableId,
    defaultSorting: DefaultSortingOptionsForPerformanceAnalysisboard,
  });

  const onClick = (isExpanded: boolean) => {
    pagesConfig.toggleFiltersTray(isExpanded);
    resetSideFilter();
  };

  const resetSideFilter = () => {
    pagesConfig.setApplyFilters(false);
    pagesConfig.setClearFilters(false);
  };

  const [view, setView] = useState<ViewType>(ViewType.Table);
  const [isCountryFirstLoad, setIsCountryFirstLoad] = useState<boolean>(true);
  const [countryChanged, setCountryChanged] = useState<boolean>(false);
  const [isFetchingLineChartApi, setIsFetchingLineChartApi] = useState<boolean>(false);
  const [onPageFirstLoad, setOnPageFirstLoad] = useState<boolean>(true);
  const [onContextBarCompleted, setOnContextBarCompleted] = useState<boolean>(false);
  const [loadingFeatureValue, setLoadingFeatureValue] = useState<boolean>(true);
  const [retailerChangedTable, setRetailerChangedTable] = useState<boolean>(false); // turns true when retailer is changed
  const [retailerChangedStackedChart, setRetailerChangedStackedChart] = useState<boolean>(false); // turns true when retailer is changed
  const { showToastMessage } = useToastMessage();
  const [areDependenciesUpdated, setAreDependenciesUpdated] = useState<boolean>(false); //This state group all the dependencies that needed for DATA api call and prevent multiple dependencies triggered.
  const [currentVolume, setCurrentVolume] = useState<string>(DEFAULT_VOLUME);
  const previousStackedChartParamsRef = useRef<FilterCriteriaParam | null>(null);
  // indicator for stacked chart sorting based on whether saved view/ copy view being applied
  const [isRestoreFromSavedView, setIsRestoreFromSavedView] = useState<boolean>(false);
  const [isMultiCountryFeatureFlagEnabled, setIsMultiCountryFeatureFlagEnabled] = useState<boolean>(false);

  //State for Sort By Dropdown in Stacked Chart view
  const [stackedChartSortingOrder, setStackedChartSortingOrder] = useState<SortFieldDisplayProps>(
    pagesConfig.sortByOptionsPerformanceAnalysisStackedChart,
  );

  const [showSelectedPeriodNotExistInCountriesWarningBox, setShowSelectedPeriodNotExistInCountriesWarningBox] =
    useState<boolean>(
      isMultiCountry
        ? !isSelectedPeriodExistInAllMultiCountries(
            updatedInitialFiltersState,
            period.label,
            periodicity,
            appliedCountries,
          )
        : false,
    );

  //need to check applied country is multi or not instead of use this flag

  const isSelectMultiCountry = useMemo((): boolean => {
    return appliedCountries.length > 1;
  }, [pagesConfig.clientId, appliedCountries]);

  //Props for custom hooks to dispatch pgs availability details
  const pgsAvailabilityProps: PgAvailabilityProps = useMemo(
    () => ({
      periodValue: period.value,
      periodicity,
      appliedCountries,
      pgsByAppliedCountry: pagesConfig.pgsByAppliedCountry,
      countriesPgsAvailabilities: pagesConfig.masterPgsByCountry,
      appliedProductGroups: appliedProductGroupOptions || [],
    }),
    [
      period.value,
      periodicity,
      appliedCountries,
      pagesConfig.pgsByAppliedCountry,
      pagesConfig.masterPgsByCountry,
      appliedProductGroupOptions,
    ],
  );

  useDispatchPgsAvailability(pgsAvailabilityProps);

  /**
   * Retrieve header key for stacked chart sorting option
   */

  const getStackedChartSortingOptionHeaderKey = (): string => {
    return pagesConfig.sortingOptionsPerformanceAnalysisStackedChart.headerKey;
  };

  const trackPageView = () => {
    const trackingParam: PageViewTrackingFunctionParam = {
      eventTitle: PAGE_VIEW_TRACKING_TITLE,
      sideFilters: sideFiltersState.appliedFilters,
      retailerClientState,
      track,
      pageType: PageType.PERFORMANCE_ANALYSIS,
      pageName: PageName.PERFORMANCE_ANALYSIS,
      access: pagesConfig.access,
      initialLocationId: getInitialAppliedCountries(pagesConfig, PageType.PERFORMANCE_ANALYSIS, effectiveProductType),
    };

    pageViewTrackingFunction(trackingParam);
  };

  const toUpdateAddFeatSegFeatValues: UpdateAddFeatSegFeatValues = {
    setSelectedAddFeat: setSelectedAddFeatOpp,
    setSelectedAddFeatValues: setSelectedAddFeatOppValues,
    setSelectedSegFeat: setSelectedSegFeatOpp,
    setSelectedSegFeatValues: setSelectedSegFeatOppValues,
  };
  /*
   * update selectedProductGroup when selectedFilters change in context
   */
  useEffect(() => {
    updateSelectedProductGroup(
      pagesConfig,
      selectedCountries,
      setSelectedCountries,
      setSelectedProductGroupOptions,
      toUpdateAddFeatSegFeatValues,
    );
  }, [pagesConfig.selectedFilters]);

  /**
   * Set currency filter as a base filter within Performance Analysis page.
   *
   * @param currencyOptionFilters - Currency filter options
   */
  const setCurrencyFilters = (currencyOptionFilters: Filters) => {
    opportunityReviewResponseConfig.response[0].filters = [currencyOptionFilters];
  };

  const pageTypeAndName: PageTypeAndName = {
    pageType: PageType.PERFORMANCE_ANALYSIS,
    pageName: PageName.PERFORMANCE_ANALYSIS,
  };

  useEffect(() => {
    //Update page viewing
    updateRetailerClient({ ...retailerClientState, pageViewing: PageName.PERFORMANCE_ANALYSIS });
    pagesConfig.setIsNavigateFromPerfAnalysis(true);

    validateStoreFilterSettings(sideFiltersState, pagesConfig, pageTypeAndName);

    // Since the currency filter is available on this page, we need to validate for any selected
    // priceband feature option.
    if (
      isRemovePricebandFilterForNonLocalCurrency(
        pagesConfig,
        sideFiltersState.appliedFilters[PageType.PERFORMANCE_ANALYSIS].selectedFilters,
        effectiveProductType,
        feature,
      )
    ) {
      setFeature(EMPTY_FEATURE_OPTION); // reset the feature
    }

    const subscriptionPeriodicities: Periodicity[] = getSubscriptionPeriodicitiesByCountryAndProductType(
      effectiveProductType,
      pagesConfig,
      appliedCountries,
    );

    const selectedPgCheckParam: SelectedPgCheckParam = {
      setShowPgModal: setShowPgModal,
      sideFiltersState: sideFiltersState,
      pagesConfig: pagesConfig,
      selectedProductGroup: selectedProductGroupOptions,
      productType: effectiveProductType,
      productDataType: ProductDataType.PerformanceAnalyzer,
      pageType: PageType.PERFORMANCE_ANALYSIS,
      appliedCountries: appliedCountries,
      timeFrame: subscriptionPeriodicities.length !== 0 ? subscriptionPeriodicities : [periodicity],
    };

    checkSelectedPgExists(selectedPgCheckParam);
    // After user selects the Country & PG from modal is value remains true hence the 'Go to market' button remains disabled
    // Setting this false will let user click 'Go to market' button.
    setLoadingFeatureValue(false);

    if (pagesConfig.isMultiCountryFeatureFlagPA) {
      // Construct currency options in side menu filter only for this page.
      setCurrencyFilters(
        constructCurrencySideMenuFilterOptions(pagesConfig, effectiveProductType, retailerClientState.clientId),
      );
    }

    //To check for feature flag on page load
    const getIsFeatureFlagEnabled = async () => {
      setIsMultiCountryFeatureFlagEnabled(true);
      pagesConfig.setIsMultiCountryDropdown(true);
    };
    getIsFeatureFlagEnabled();
    //Do not load this amplitude tracking on very first load
    if (
      appliedCountries.length !== 0 &&
      appliedProductGroupOptions !== undefined &&
      appliedProductGroupOptions.length !== 0
    ) {
      trackPageView();
    }
    // To ensure getting the correct timeFrame and period when first load due to race conditions issue that we have right now
    setOnPageFirstLoad(false);
  }, []);

  useEffect(() => {
    //Make initial amplitude load after context bar is completed
    if (onContextBarCompleted) {
      trackPageView();
    }
  }, [onPageFirstLoad, onContextBarCompleted]);

  /**
   * useEffect that updates period set & filter When the applied countries is changed, pgs-by-focus-period and product-group API is triggered
   */
  useEffect(() => {
    (async () => {
      const clientId = retailerClientState.clientId;
      setPgsByAppliedCountries([]);
      const availableMasterPgs = await getProductGroupsMasterByCountry(
        clientId,
        appliedCountries,
        effectiveProductType,
      );
      pagesConfig.setMasterPgsByCountry(availableMasterPgs);

      if (!isCountryFirstLoad) {
        const updatePeriodParamsORPA = {
          givenPeriodCombo: { period, periodicity, comparisonPeriod },
          supportedPeriodicities,
          pagesConfig,
          appliedCountries,
          selectedCountries,
          defaultFilters,
          updatePeriod: periodDispatchActions.updatePeriod,
          updatePeriodicity: periodDispatchActions.updatePeriodicity,
          updateComparisonPeriod: periodDispatchActions.updateComparisonPeriod,
          updateCustomMonthsPeriodState: periodDispatchActions.updateCustomMonthsPeriodState,
          setFilters,
          setCountryChanged,
          customMonthsPeriod: customMonthsPeriodState,
        };
        updatePeriodFiltersWhenCountryChange(
          updatePeriodParamsORPA,
          isMultiCountry,
          getLatestPeriodAmongAppliedCountries(appliedCountries, initialFiltersState),
        );
      }
      if (
        !checkPGsByCountryPrecondition(
          pagesConfig,
          clientId,
          periodicity,
          sideFiltersState.appliedFilters,
          appliedCountries,
        )
      ) {
        return;
      }
      updatePgsByCountryOnCountryApplyWithProductType(
        pagesConfig,
        clientId,
        selectedCountries,
        appliedCountries,
        effectiveProductType,
        undefined,
        setPgsByAppliedCountries,
      );
    })();
  }, [appliedCountries]);
  //endregion

  useEffect(() => {
    // Reset total page and current page to default number when apply the filters
    setTotalPage(defaultTotalPageNumber);
    setCurrentPage(defaultPageNumber);
    if (allFiltersForPA.length !== 0) {
      const pgIndex = allFiltersForPA.findIndex((e) => e.filterKey === FilterKeys.PRODUCT_GROUP);
      if (pgIndex !== -1) {
        setSelectedProductGroupOptions(cloneDeep(allFiltersForPA[pgIndex].options));
        setAppliedProductGroupOptions(cloneDeep(allFiltersForPA[pgIndex].options));
      }

      const countryIndex = allFiltersForPA.findIndex((e) => e.filterKey === FilterKeys.COUNTRY);
      if (countryIndex !== -1) {
        setIsCountryFirstLoad(false);
        setAppliedCountries(cloneDeep(allFiltersForPA[countryIndex].options));
        setSelectedCountries(cloneDeep(allFiltersForPA[countryIndex].options));
        pagesConfig.setMultiCountryClientCountries(cloneDeep(allFiltersForPA[countryIndex].options));
      }
    }

    setFeatureValuesWeeklyMonthlyFeatures();

    setLoadingLineChartData(true);
  }, [pagesConfig.appliedFilters]);

  /**
   * Use this function to determine if the selected timeframe is inherently a monthly timeframe.
   * E.g. Both rolling/calendar quarter periodicities display as monthly periods
   */
  const isMonthlyPeriodicity = () =>
    [Periodicity.Monthly, Periodicity.CalendarQuarter, Periodicity.RollingQuarter, Periodicity.CustomMonths].includes(
      periodicity,
    );

  const getDisabledFilterKeysByAppliedCurrency = () => {
    const countryFilter = allFiltersForPA.find(byFilterKey(FilterKeys.COUNTRY));
    const currencyFilter = allFiltersForPA.find(byFilterKey(FilterKeys.CURRENCY));

    if (
      !countryFilter ||
      !currencyFilter ||
      isLocalCurrencyApplied(pagesConfig, effectiveProductType, currencyFilter, countryFilter)
    ) {
      return [];
    }
    return multiCountryDisabledFilters;
  };

  const setFeatureValuesWeeklyMonthlyFeatures = () => {
    if (weeklyMonthlyFeatures && periodicity && isMonthlyPeriodicity()) {
      setAllFeatureValues(weeklyMonthlyFeatures.monthly);
      setFeature(getFeatureSelector(weeklyMonthlyFeatures.monthly, feature, getDisabledFilterKeysByAppliedCurrency()));
    }

    if (weeklyMonthlyFeatures && periodicity && periodicity === Periodicity.Weekly) {
      setAllFeatureValues(weeklyMonthlyFeatures.weekly);
      setFeature(getFeatureSelector(weeklyMonthlyFeatures.weekly, feature, getDisabledFilterKeysByAppliedCurrency()));
    }
  };

  useEffect(() => {
    const handleStackedChartSegmentSelectParams: HandleStackedChartSegmentSelectParams = {
      allFeatureValues: allFeatureValuesForPA,
      selectedPgOptions: selectedProductGroupOptions,
      appliedPgOptions: appliedProductGroupOptions,
      selectedSegmentOption: segmentByFeature,
      setSelectedSegmentOption: setSegmentByFeature,
      showPerformanceWithinOption: feature,
      hasUserClickedApplyAtSideFilters: false,
      disabledFeatureValues: getDisabledFilterKeysByAppliedCurrency(),
    };

    handleStackedChartSegmentSelect(handleStackedChartSegmentSelectParams);
  }, [feature]);

  useEffect(() => {
    const clientId = retailerClientState.clientId;
    if (
      !checkPGsByCountryPrecondition(
        pagesConfig,
        clientId,
        periodicity,
        sideFiltersState.appliedFilters,
        selectedCountries,
      )
    ) {
      return;
    }

    const filter = opportunityReviewResponseConfig.response[0];
    updatePgsByCountryOnCountrySelectWithProductType(
      pagesConfig,
      clientId,
      periodicity,
      filter,
      selectedCountries,
      effectiveProductType,
    );
  }, [periodicity, selectedCountries, pagesConfig.pgsByPage, pagesConfig.pageType]);

  useEffect(() => {
    const payload = {
      selectedGrowthType: selectedGrowthType,
      feature: feature,
      segmentByFeature: view === ViewType.StackedChart ? segmentByFeature : undefined,
    };
    updateMainFilters(payload);

    const mainFiltersMarketPremium = {
      timeFrame: periodicity,
      period,
      comparisonPeriod,
      selectedGrowthType,
      feature,
    };
    updateMainFiltersMarketPremium(mainFiltersMarketPremium);
  }, [feature, selectedGrowthType, segmentByFeature, view]);

  /**
   * Construct the options for feature selector when time frame is changed and set the selected features
   */
  useEffect(() => {
    // when timeFrame is changed, whatever that is not applied in filter tray will be reset, selectedCountries and selectedProductGroup reset
    removeUnsavedFilters(pagesConfig);

    if (weeklyMonthlyFeatures && periodicity && isMonthlyPeriodicity()) {
      setAllFeatureValues(weeklyMonthlyFeatures.monthly);
    }

    if (weeklyMonthlyFeatures && periodicity && periodicity === Periodicity.Weekly) {
      setAllFeatureValues(weeklyMonthlyFeatures.weekly);
    }

    if (weeklyMonthlyFeatures) {
      setFeature(
        getFeatureSelector(
          periodicity === Periodicity.Weekly ? weeklyMonthlyFeatures.weekly : weeklyMonthlyFeatures.monthly,
          feature,
        ),
      );
    }
  }, [periodicity, period]);

  /*
   * calls API and updates filter options when selectedProductGroup and selectedCountry is changed
   * The contextApplied check is needed to prevent API call with wrong pg country combo when user applies context in pg modal
   * The isNavigateFromOpportunity is needed to prevent duplicate API call when user navigates from OR page
   */
  useDebouncedEffect(() => {
    getFeatureValuesForPA();
  }, [selectedProductGroupOptions, appliedCountries, selectedCountries, periodicity]);

  const getFeatureValueParam = (): FilterParam => {
    return {
      productType: effectiveProductType,
      selectedProductGroup: selectedProductGroupOptions,
      initialFilters: defaultFilters,
      selectedCountries: selectedCountries,
      pagesConfig: pagesConfig,
      responseConfig: opportunityReviewResponseConfig,
      allFilters: allFiltersForPA,
      subscriptions: getSubscriptionByCountryAndProductType(pagesConfig, selectedCountries, effectiveProductType),
    };
  };

  /**
   * Get feature values for feature selector by monthly and weekly
   */
  const getFeatureValuesForPA = async () => {
    let combinedFeaturesForPA: WeeklyMonthlyFeatures = {
      weekly: [],
      monthly: [],
    };
    //Prevent call before pgModal apply
    if (onPageFirstLoad || showPgModal) {
      return;
    }

    setLoadingFeatureValue(true);
    const countryFilter = pagesConfig.selectedFilters[PageType.PERFORMANCE_ANALYSIS].selectedFilters.find(
      byFilterKey(FilterKeys.COUNTRY),
    )!;
    const countryList = countryFilter.options.map((country) => country.value);

    let currentFilter =
      countryList.length > 1
        ? getMainFiltersList(period, defaultFilters, countryList)[0]
        : defaultFilters.find((fil) => fil.country === countryList[0]);

    if (periodicity === Periodicity.Weekly) {
      await getWeeklyFeatureValues(combinedFeaturesForPA, currentFilter);
    } else {
      await getMonthlyFeatureValues(combinedFeaturesForPA, currentFilter);
    }

    setLoadingFeatureValue(false);
  };

  const getMonthlyFeatureValues = async (combinedFeaturesForPA: WeeklyMonthlyFeatures, currentFilter?: MainFilters) => {
    if (currentFilter?.timeFrame.monthly) {
      const monthlyFeaturesForPA = await getFeatureValueBySubscription(
        constructFeatureValueParam(getFeatureValueParam(), Periodicity.Monthly),
        periodicity,
        CURRENT_TOTAL_NAME,
        setPeriodicityNotSubscribedAndReset,
      );
      if (monthlyFeaturesForPA) {
        combinedFeaturesForPA.monthly = monthlyFeaturesForPA;
        setWeeklyMonthlyFeatures(combinedFeaturesForPA);

        // allFeatureValuesForPA is applied only
        if (periodicity && isMonthlyPeriodicity()) {
          if (isAppliedFiltersEqualToSelectedFilters(pagesConfig)) {
            setAllFeatureValues(combinedFeaturesForPA.monthly);
          }
        }
      }
    }
  };

  const getWeeklyFeatureValues = async (combinedFeaturesForPA: WeeklyMonthlyFeatures, currentFilter?: MainFilters) => {
    if (currentFilter?.timeFrame.weekly) {
      const weeklyFeatureForPA = await getFeatureValueBySubscription(
        constructFeatureValueParam(getFeatureValueParam(), Periodicity.Weekly),
        periodicity,
        CURRENT_TOTAL_NAME,
        setPeriodicityNotSubscribedAndReset,
      );
      if (weeklyFeatureForPA) {
        combinedFeaturesForPA.weekly = weeklyFeatureForPA;
        setWeeklyMonthlyFeatures(combinedFeaturesForPA);

        // allFeatureValuesForPA is applied only
        if (periodicity && periodicity === Periodicity.Weekly) {
          if (isAppliedFiltersEqualToSelectedFilters(pagesConfig)) {
            setAllFeatureValues(combinedFeaturesForPA.weekly);
          }
        }
      }
    }
  };

  useEffect(() => {
    const periodTimeFrame: Periodicity = getPeriodForFeatures(pagesConfig, periodicity, selectedCountries);
    getSelectedAddFeatValues({
      productType: effectiveProductType,
      selectedProductGroup: selectedProductGroupOptions,
      selectedAddFeatValues: selectedAddFeatPerValues,
      selectedAddFeat: selectedAddFeatPer,
      initialFilters: defaultFilters,
      selectedCountries,
      pagesConfig,
      selectedTimeFrame: periodTimeFrame,
    });
  }, [selectedAddFeatPerValues]);

  useEffect(() => {
    const periodTimeFrame: Periodicity = getPeriodForFeatures(pagesConfig, periodicity, selectedCountries);
    getSelectedSegFeatValues({
      productType: effectiveProductType,
      selectedProductGroup: selectedProductGroupOptions,
      selectedSegFeatValues: selectedSegFeatPerValues,
      selectedSegFeat: selectedSegFeatPer,
      initialFilters: defaultFilters,
      selectedCountries,
      pagesConfig,
      selectedTimeFrame: periodTimeFrame,
    });
  }, [selectedSegFeatPerValues]);

  //Performance Analysis Table View
  const [selectedShareType, setSelectedShareType] = useState<ShareType>(ShareType.MarketShare);
  const [loadMore, setLoadMore] = useState<boolean>(false);

  const [isApiError, setIsApiError] = useState<boolean>(false);
  const [performanceAnalysisboardPg, setPerformanceAnalysisboardPg] = useState<PerformanceAnalysisboardPg[]>([]);
  const [performanceAnalysisboardTotalSize, setPerformanceAnalysisboardTotalSize] = useState<number>(0); //This state is to store the total size of Analysisboard in order to get all the data while exporting Table/Bar chart
  const [doubleBarChartData, setDoubleBarChartData] = useState<PerformanceAnalysisboardPg[]>([]);
  const [stackedChartRespData, setStackedChartRespData] = useState<StackedChartResp[]>([]);
  const shareTypeRef = useRef(ShareType.MarketShare);
  shareTypeRef.current = selectedShareType;

  const [currentSortingOption, setCurrentSortingOption] = useState<SortingOptions>(
    DefaultSortingOptionsForPerformanceAnalysisboard,
  );

  const countriesToQuery = useMemo(() => {
    const allowedCountries = isMultiCountry
      ? getCountriesByAccessibleProductGroup(pagesConfig, periodicity, appliedCountries, appliedProductGroupOptions)
      : appliedCountries;

    return pagesConfig.clientCountries.filter((x) => allowedCountries.some((y) => x.id === y.value));
  }, [
    isMultiCountry,
    appliedCountries,
    pagesConfig.clientCountries,
    pagesConfig.pgsByCountry,
    appliedProductGroupOptions,
    periodicity,
  ]);

  const [queryCountries, setQueryCountries] = useState<Country[]>(countriesToQuery);

  useEffect(() => {
    if (
      retailerClientState.clientId === -1 ||
      period.value === '' ||
      !period.value ||
      !comparisonPeriod ||
      !queryCountries ||
      queryCountries.length === 0 ||
      !checkPeriodExist(defaultFilters, queryCountries[0].id, periodicity)
    ) {
      return;
    }

    /*
     * when onChangeHandler is called, this useEffect will execute twice due to dependencies on feature & period
     * this check is used to prevent performanceAnalysisUpdate from being updated twice, and in turn calling the API twice
     */
    if (retailerChangedTable) {
      setRetailerChangedTable(false);
      return;
    }
    //Below these is to help out rendering of isLoading component
    switch (view) {
      case ViewType.LineChart:
        setLoadingLineChart(true);
        break;

      case ViewType.BarChart:
      case ViewType.Table:
        setLoadingTableAndDoubleBarChart(true);
        break;
    }
  }, [
    feature,
    period,
    comparisonPeriod,
    selectedGrowthType,
    pagesConfig.sortingOptions,
    pagesConfig.sortingOptionsPerformanceAnalysisStackedChart,
    pagesConfig.appliedFilters,
  ]);

  useEffect(() => {
    if (view === ViewType.StackedChart) {
      setLoadingStackedChart(true);
    }
  }, [segmentByFeature]);

  const checkValidComparisonPeriod = () => {
    const periodMeta = getPeriodMeta(period.label, comparisonPeriod, periodicity)!;

    return !(
      periodMeta.comparisonPeriod.toLowerCase().includes('-nan') ||
      periodMeta.comparisonPeriod.toLowerCase().includes('week -1')
    );
  };

  const defaultPageNumber = 0;
  const defaultTotalPageNumber = 1;
  const defaultPageSizeForTable = 10;
  const defaultPageSizeForDoubleBarChart = 20;
  const defaultLargestPageSize = defaultPageSizeForDoubleBarChart;
  const [currentPage, setCurrentPage] = useState<number>(defaultPageNumber);
  const [totalPage, setTotalPage] = useState<number>(defaultTotalPageNumber);

  const isLastPage = () => {
    return currentPage >= totalPage - 1;
  };

  const handleScroll = async () => {
    if (!checkValidComparisonPeriod()) {
      return;
    }

    if (
      !loadMore &&
      !isLastPage() &&
      pagesConfig.sortingOptions === currentSortingOption &&
      view === ViewType.Table &&
      !loadingTableAndDoubleBarChart
    ) {
      const pageNumber = currentPage + 1;
      setLoadMore(true);
      setIsApiError(false);

      if (performanceAnalysisboardParam) {
        getPerformanceAnalysisBoard(performanceAnalysisboardParam, {
          page: pageNumber,
          size: defaultPageSizeForTable,
        } as PageRequest)
          .then((performanceAnalysisboardData) => {
            setPerformanceAnalysisboardPg([...performanceAnalysisboardPg, ...performanceAnalysisboardData.content]);
            setCurrentPage(pageNumber);
            setLoadMore(false);
          })
          .catch((err: any) => {
            setLoadMore(false);
            saveErrorLog(err, 'Performance Analysis Board - get performance analysis board data.', {
              category: ErrorTagEnum.ApiError,
              requestPayload: {
                clientId: retailerClientState.clientId,
                productGroup: appliedProductGroupOptions,
                period: period.value,
                comparisonPeriod: comparisonPeriod,
                periodType: periodicity,
                segment: feature.feature,
                appliedFilters: allFiltersForPA,
              },
            });
            setApiErrorState(err, setIsApiError);
          });
      }
    }
  };

  useBottomScrollListener(handleScroll, { offset: 500 });

  // For the loading indicator
  const [loadingTableAndDoubleBarChart, setLoadingTableAndDoubleBarChart] = useState<boolean>(true);
  const [loadingLineChart, setLoadingLineChart] = useState<boolean>(false);
  const [loadingOverlay, setLoadingOverlay] = useState<boolean>(false);

  // To trigger api call
  const [loadingLineChartData, setLoadingLineChartData] = useState<boolean>(false);

  const isKpiLoading = (): boolean => {
    if (view === ViewType.LineChart && loadingLineChart) {
      return true;
    } else if ((view === ViewType.Table || view === ViewType.BarChart) && loadingTableAndDoubleBarChart) {
      return true;
    } else {
      return view === ViewType.StackedChart && loadingStackedChart;
    }
  };
  const [lineChartPerformance, setLineChartPerformance] = useState(new ExportPerformanceBySegmentResp());

  const [selectedKpi] = useState<Option>(kpiDropdownOptions(currentVolume)[3]);
  const selectedKpiRef = useRef(selectedKpi);
  selectedKpiRef.current = selectedKpi;

  const filterCurrencyFilterForWeeklyYTDOrMAT = (currentAppliedFilters: Filters[]) => {
    return currentAppliedFilters;
  };

  const loadPerformanceAnalysisLineChart = (featureOption: FeatureOption) => {
    const responseTimeFrame = checkPeriodExist(defaultFilters, queryCountries[0]?.id, periodicity);

    if (responseTimeFrame !== null) {
      if (!isFetchingLineChartApi) {
        setIsFetchingLineChartApi(true);
        let kpi = matchKPI(pagesConfig.sortingOptions, kpiDropdownOptions(currentVolume));
        const perfAnalysisParam: PerformanceAnalysisParam = {
          clientId: retailerClientState.clientId,
          productType: effectiveProductType,
          productGroup: appliedProductGroupOptions,
          countries: queryCountries,
          period: period.value,
          comparisonPeriod: RelativePeriod.PreviousYearCurrentPeriod,
          periodType: periodicity,
          selectedGrowthType: selectedGrowthType,
          saleType: kpi.salesType,
          appliedFilters: allFiltersForPA,
          kpi: kpi.value,
          segment: featureOption.feature,
          dataType: featureOption.dataType,
          isSummary: false,
        };
        setPerformanceAnalysisParam(perfAnalysisParam);

        if (
          (view === ViewType.BarChart && !loadingLineChartData) ||
          (view === ViewType.StackedChart && !loadingLineChartData)
        ) {
          setIsFetchingLineChartApi(false);
          setIsFetchingApiLatest(false);
          setLoadingLineChart(false);
          setAreDependenciesUpdated(false);
        } else {
          getExportPerformanceAnalysisLineChart(perfAnalysisParam)
            .then((performanceValue) => {
              setIsFetchingLineChartApi(false);
              setLineChartPerformance(performanceValue);
            })
            .finally(() => {
              setIsFetchingApiLatest(false);
              setLoadingLineChart(false);
              setLoadingLineChartData(false);
              setAreDependenciesUpdated(false);
              clearExportImage();
            })
            .catch((err: any) => {
              setLineChartPerformance(new ExportPerformanceBySegmentResp());
              saveErrorLog(err, 'Performance Analysis Board - get line chart error.', {
                category: ErrorTagEnum.ApiError,
                requestPayload: {
                  clientId: retailerClientState.clientId,
                  productGroup: appliedProductGroupOptions,
                  period: period.value,
                  comparisonPeriod: comparisonPeriod,
                  periodType: periodicity,
                  segment: feature.feature,
                },
              });
              if (err.message === 'Cancel: Operation canceled due to new request.') {
                return;
              }
              setIsFetchingLineChartApi(false);
              setLoadingLineChart(false);
            });
        }
      }
    }
  };

  const getStackChartCollectionParams = (): FilterCriteriaParam => {
    const kpi = mapStackedChartKPI(getStackedChartSortingOptionHeaderKey(), kpiDropdownOptions(currentVolume));
    const showPerformanceWithinOption = getFeatureSelector(allFeatureValuesForPA, feature);
    return {
      clientId: retailerClientState.clientId,
      productType: effectiveProductType,
      countries: pagesConfig.clientCountries.filter((x) => appliedCountries.some((y) => x.id === y.value)),
      productGroup: appliedProductGroupOptions,
      period: period.value,
      comparisonPeriod: comparisonPeriod,
      periodType: periodicity,
      shareType: selectedShareType,
      appliedFilters: filterCurrencyFilterForWeeklyYTDOrMAT(allFiltersForPA),
      segmentName: showPerformanceWithinOption.feature,
      segmentDataType: showPerformanceWithinOption.dataType,
      kpi: kpi.value,
      segmentBy: segmentByFeature.feature,
      segmentByDataType: segmentByFeature.dataType,
    };
  };

  const getStackedChartResp = async (kpi: any, featureOption: FeatureOption, byFeatureOption: FeatureOption) => {
    const stackedChartParams: FilterCriteriaParam = {
      clientId: retailerClientState.clientId,
      productType: effectiveProductType,
      countries: queryCountries,
      productGroup: appliedProductGroupOptions,
      period: period.value,
      comparisonPeriod: comparisonPeriod,
      periodType: periodicity,
      shareType: selectedShareType,
      appliedFilters: filterCurrencyFilterForWeeklyYTDOrMAT(allFiltersForPA),
      segmentName: featureOption.feature,
      segmentDataType: featureOption.dataType,
      kpi: kpi.value,
      segmentBy: byFeatureOption.feature,
      segmentByDataType: byFeatureOption.dataType,
    };
    const hasParamsChanged =
      !previousStackedChartParamsRef.current ||
      JSON.stringify(previousStackedChartParamsRef.current) !== JSON.stringify(stackedChartParams);
    if (hasParamsChanged || stackedChartRespData.length === 0) {
      previousStackedChartParamsRef.current = stackedChartParams;
      getStackedChart(stackedChartParams)
        .then((successStackedChartData) => {
          setStackedChartRespDataWithSorting(successStackedChartData);
          setLoadingStackedChart(false);
        })
        .finally(() => {
          setIsFetchingApiLatest(false);
          setAreDependenciesUpdated(false);
        })
        .catch((err: any) => {
          setLoadingStackedChart(false);
          setStackedChartRespDataWithSorting([]);
          saveErrorLog(err, 'Performance Analysis Board - get stack chart data.', {
            category: ErrorTagEnum.ApiError,
            requestPayload: {
              clientId: retailerClientState.clientId,
              productGroup: appliedProductGroupOptions,
              period: period.value,
              comparisonPeriod: comparisonPeriod,
              periodType: periodicity,
              segment: feature.feature,
            },
          });
        });
    } else {
      setLoadingStackedChart(false);
      setStackedChartRespDataWithSorting(stackedChartRespData);
    }
  };

  const setDisplayForDoubleBarChart = (performanceAnalysisboardData: any) => {
    if (selectedShareType === ShareType.MarketShare) {
      setDoubleBarChartData(performanceAnalysisboardData.content.slice(0, defaultPageSizeForDoubleBarChart));
    }
  };

  const loadPerformanceAnalysisTable = (featureOption: FeatureOption) => {
    const responseTimeFrame = checkPeriodExist(defaultFilters, queryCountries[0]?.id, periodicity);

    const perfAnalysisboardParam: PerformanceAnalysisboardParam = {
      clientId: retailerClientState.clientId,
      productType: effectiveProductType,
      countryIds: queryCountries.map((x) => x.id),
      productGroup: appliedProductGroupOptions,
      period: period.value,
      comparisonPeriod: comparisonPeriod,
      periodType: periodicity,
      shareType: selectedShareType,
      sortOption: pagesConfig.sortingOptions,
      growthType: selectedGrowthType,
      appliedFilters: filterCurrencyFilterForWeeklyYTDOrMAT(allFiltersForPA),
      segment: featureOption.feature,
      dataType: featureOption.dataType,
    };
    setPerformanceAnalysisboardParam(perfAnalysisboardParam);
    if (responseTimeFrame !== null) {
      setIsApiError(false);
      // Getting the timeFrame and period from redux state on page first load, subsequent will be getting from local state
      getPerformanceAnalysisBoard(perfAnalysisboardParam, {
        page: defaultPageNumber,
        size: defaultLargestPageSize,
      } as PageRequest)
        .then((performanceAnalysisboardData) => {
          if (performanceAnalysisboardData.content.length !== 0) {
            const calculateTotalPage = (totalElements: number) => {
              // defaultLargestPageSize does not always reflect page size for table, use manual calculation instead
              return Math.ceil(totalElements / defaultPageSizeForTable);
            };

            setCurrentPage(defaultPageNumber);
            setTotalPage(calculateTotalPage(performanceAnalysisboardData.pageable.totalElements));
            setPerformanceAnalysisboardPg(performanceAnalysisboardData.content.slice(0, defaultPageSizeForTable));
            setPerformanceAnalysisboardTotalSize(performanceAnalysisboardData.pageable.totalElements);
            setDisplayForDoubleBarChart(performanceAnalysisboardData);
            setCurrentSortingOption(pagesConfig.sortingOptions);
          } else {
            // Reset to default total page
            setTotalPage(defaultTotalPageNumber);
            // Set to empty array if no data
            setPerformanceAnalysisboardPg([]);
            setDoubleBarChartData([]);
          }
        })
        .finally(() => {
          setLoadingTableAndDoubleBarChart(false);
          setIsFetchingApiLatest(false);
          setAreDependenciesUpdated(false);
        })
        .catch((err: any) => {
          setPerformanceAnalysisboardPg([]);
          setDoubleBarChartData([]);
          console.error(err);
          setIsFetchingApiLatest(false);
          setAreDependenciesUpdated(false);
          saveErrorLog(err, 'Performance Analysis Board - get performance analysis board data.', {
            category: ErrorTagEnum.ApiError,
            requestPayload: {
              clientId: retailerClientState.clientId,
              productGroup: appliedProductGroupOptions,
              period: period.value,
              comparisonPeriod: comparisonPeriod,
              periodType: periodicity,
              segment: feature.feature,
            },
          });
          setLoadingTableAndDoubleBarChart(false);
          setApiErrorState(err, setIsApiError);
        });
    }
    setOnPageFirstLoad(false);
  };

  useEffect(() => {
    if (
      !isValidStackedChartCall({
        showWithinSelectorOption: feature,
        bySelectorOption: segmentByFeature,
        periodicity: periodicity,
        periodSelection: period,
        allFeatureValues: allFeatureValuesForPA,
        isLoadingStackedChart: loadingStackedChart,
      })
    ) {
      return;
    }

    /*
     * when onChangeHandler is called, this useEffect will execute twice due to dependencies on feature & period
     * this check is used to prevent isStackedChartUpdated from being updated twice, and in turn calling the API twice
     */
    if (retailerChangedStackedChart) {
      setRetailerChangedStackedChart(false);
    }
  }, [
    feature,
    periodicity,
    period,
    comparisonPeriod,
    pagesConfig.sortingOptionsPerformanceAnalysisStackedChart,
    segmentByFeature,
  ]);

  const loadPerformanceAnalysisStackChart = (featureOption: FeatureOption, byFeatureOption: FeatureOption) => {
    let kpi = mapStackedChartKPI(getStackedChartSortingOptionHeaderKey(), kpiDropdownOptions(currentVolume));
    getStackedChartResp(kpi, featureOption, byFeatureOption);
  };

  //To roll back the selected feature if channel is selected and switch to stack chart for france
  const rollBackFeature = () => {
    const rollBackFeatureOption = getFeatureSelector(allFeatureValuesForPA, feature, [FilterKeys.CHANNEL]);
    setFeature(rollBackFeatureOption);
    featureHandler();
  };

  useEffect(() => {
    setPeriodDisabled(view === ViewType.LineChart);

    if (
      view === ViewType.StackedChart &&
      queryCountries[0]?.id === France.id &&
      feature.filterKey === FilterKeys.CHANNEL
    ) {
      rollBackFeature();
    }
  }, [view]);

  /**
   * To handle the change event when select other retailer in the retailer dropdown - reset the necessary states in order to refresh the reports
   * @param subscriptions client subscription from opa policy
   */
  const onChangeHandler = async (subscriptions: ClientSubscription[]) => {
    setLoadingOverlay(true);

    const subscribedCountries = mapSubscribedCountries(subscriptions);

    // Default clientId, but the clientId should be always the same no matter how many countries the client has
    const defaultClientId = subscriptions[0].retailer;

    // Default country, retain the countries selection if exists in the subscription
    const defaultCountry = mapDefaultSubscribedCountry(subscriptions, appliedCountries);
    const defaultCountryCode = defaultCountry.countryCode;

    // get hitlists subscription. current assumption is that it exist
    const hitlistsSubscriptions = getSubscriptionForOtherProducts(
      ProductType.ProductAnalyzer,
      pagesConfig,
      defaultClientId,
    );
    const hitlistsSubscribedCountries = mapSubscribedCountries(hitlistsSubscriptions);

    // Get the current side menu filters selection from pagesConfig
    const pagesConfigAllFilters = [...pagesConfig.appliedFilters];

    //Retrieve client name
    const selectedClientName = getSelectedClientNameWithClientId(retailerClients, defaultClientId);

    if (hitlistsSubscribedCountries.length !== 0) {
      const onChangePAMethodParam: OnRetailerChangeParam = {
        subscriptions: hitlistsSubscriptions,
        appliedCountries,
        defaultClientId,
        pagesConfig,
        productType: ProductType.ProductAnalyzer,
        productDataType: ProductDataType.ProductAnalyzer,
        subscribedCountries: hitlistsSubscribedCountries,
        setLoadingOverlay: (_) => {},
        timeFrame: periodicity,
        pagesConfigAllFilters,
        pageName: PageName.PERFORMANCE_ANALYSIS,
        pageList: [PageType.RI_PRODUCT],
      };
      await onChangeHandlerForOtherProducts(onChangePAMethodParam).then((response) => {
        if (!response) {
          return;
        }
        // if update to react 18 and above, can remove call to batch function
        batch(() => {
          updateMainFiltersProducts({
            timeFrame: response.currTimeFrame,
            period: response.currPeriod,
            comparisonPeriod: RelativePeriod.PreviousYearCurrentPeriod,
            selectedGrowthType: mainFilterStateProducts.selectedGrowthType,
            country: response.defaultCountryCode,
          });
          updateInitialFiltersProducts({ initialFilters: response.filtersData });
          updateHitlistsRetailerClient(
            constructRetailerClientState(defaultClientId, hitlistsSubscribedCountries, selectedClientName),
          );
        });
      });

      constructCountryOptionForSideMenu(pagesConfigAllFilters, defaultCountry, [PageType.RI_PRODUCT]);
    }

    const filtersData = await getFiltersForClient(
      defaultClientId,
      subscribedCountries,
      (_) => {},
      effectiveProductType,
      ProductDataType.PerformanceAnalyzer,
    );

    const filtersDataBasedOnCountry = filtersData.find((filter) => filter.country === defaultCountryCode);

    await getAndStoreSavedFilters(effectiveProductType, defaultClientId, pagesConfig, pagesConfig.userId);
    setDefaultFilters(filtersData);

    if (!filtersDataBasedOnCountry) {
      saveErrorLogForOnChange(pagesConfig.clientCountries, pagesConfig.appliedFilters, PageName.PERFORMANCE_ANALYSIS);
      setLoadingOverlay(false);
      return;
    }

    constructCountryOptionForSideMenu(pagesConfigAllFilters, defaultCountry, [
      PageType.RETAILER_OVERVIEW,
      PageType.CATEGORY_LEADERBOARD,
      PageType.OPPORTUNITY_REVIEW,
      PageType.PERFORMANCE_ANALYSIS,
    ]);

    if (pagesConfig.isMultiCountryFeatureFlagPA) {
      // Construct new currency filter based on applied default country
      const currentlyAppliedFilters = pagesConfigAllFilters[PageType.PERFORMANCE_ANALYSIS].selectedFilters;
      updateAppliedCurrencyFilterByCountry(
        pagesConfig,
        constructCountryOption(defaultCountry)[0],
        currentlyAppliedFilters,
      );

      // Reset currency dropdown side menu filter options
      setCurrencyFilters(constructCurrencySideMenuFilterOptions(pagesConfig, effectiveProductType, defaultClientId));
    }

    const storeFilterSettings = {
      appliedFilters: pagesConfigAllFilters,
    };
    const marketPremiumSubscription = getSubscriptionForOtherProducts(
      ProductType.MarketPremium,
      pagesConfig,
      defaultClientId,
    );
    const marketPremiumSubscribedCountries = mapSubscribedCountries(marketPremiumSubscription);
    resetSideFilter();

    // if update to react 18 and above, can remove call to batch function
    batch(() => {
      updateSideFilters(storeFilterSettings);
      updateInitialFilters({ initialFilters: filtersData });

      updateMainFilters({
        selectedGrowthType: selectedGrowthType,
        feature: feature,
      });

      updateRetailerClient(
        constructRetailerClientState(
          defaultClientId,
          subscribedCountries,
          selectedClientName,
          PageName.PERFORMANCE_ANALYSIS,
        ),
      );

      if (marketPremiumSubscribedCountries.length > 0) {
        updateInitialFiltersMarketPremium({ initialFilters: filtersData });
        updateMarketPremiumRetailerClient(
          constructRetailerClientState(
            defaultClientId,
            subscribedCountries,
            selectedClientName,
            PageName.PERFORMANCE_ANALYSIS,
          ),
        );
        pagesConfig.setMarketPremiumClientId(defaultClientId);
        pagesConfig.setMarketPremiumClientCountries(subscribedCountries);
      }

      updateMainFiltersRO({
        country: defaultCountryCode,
      });

      /**
       * The reset sequence below is very important, this is due to the massive useEffect that we have in the page
       * If you don't update the pagesConfig before setFeature feature won't be updated.
       */
      // Do not simply move the setState below, it will trigger unintended side effects
      pagesConfig.setClientCountries(subscribedCountries);
      pagesConfig.setClientId(defaultClientId);
      pagesConfig.setSelectedFilters(pagesConfigAllFilters);
      if (hitlistsSubscriptions.length !== 0) {
        pagesConfig.setHitlistsClientCountries(hitlistsSubscribedCountries);
        pagesConfig.setHitlistsClientId(defaultClientId);
      }

      setSelectedCountries(constructCountryOption(defaultCountry));

      setFilters(filtersDataBasedOnCountry);

      setAppliedCountries(constructCountryOption(defaultCountry));

      setRetailerChangedTable(true);
      setRetailerChangedStackedChart(true);
      setLoadingTableAndDoubleBarChart(true);
      setLoadingLineChart(true);
      setLoadingStackedChart(true);
    });
    refetch();

    // Updates the selected period upon multibanner change.
    // Uses the latest period of the default country upon retailer change

    const countryOptions = constructCountryFilter(constructCountryOption(defaultCountry));

    if (defaultCountry) {
      let latestTimePeriodOption = getLatestPeriodByPeriodicityForSingleCountry(
        countryOptions,
        mainFiltersState,
        filtersData,
      );
      if (latestTimePeriodOption === undefined) {
        latestTimePeriodOption = {
          label: '',
          value: '',
          lastUpdatedDate: 0,
        };
      }
      periodDispatchActions.updatePeriod(latestTimePeriodOption);
    }

    setLoadingOverlay(false);
  };

  const multipleChartsExport = useMultipleChartsExport(2);
  const [invokeExport, onChartExportReady] = useChartExport();
  const { download: exportLineChart } = useExportMultiChart();
  const { download: exportStackedChart } = useExportStackedChart();
  const { download: exportTable } = useExportTable([]);

  let selectedStackedChartKPI = mapStackedChartKPI(
    getStackedChartSortingOptionHeaderKey(),
    kpiDropdownOptions(currentVolume),
  );

  const handleDataExportTrackingFunction = useDataExportTracking('mainFilters');

  const handleExportedTracking = (
    elementType: ElementType,
    exportFormats: ExportFormat[],
    elementKpi?: string,
    elementSort?: SortingOptionsType,
  ) => {
    const dataExportedTrackingParam: DataExportTrackingElementParam = {
      elementType,
      elementKpi,
      elementSort,
      optionChosen: exportFormats.map((format) => getExportTrackingFormat(format)),
    };
    handleDataExportTrackingFunction(dataExportedTrackingParam, dataExportedTrackingFunction);
  };

  const factRevenueBySelectedCurrency = useFactRevenueBySelectedCurrency(
    pagesConfig,
    appliedCountries,
    effectiveProductType,
  );

  const onChartDownload = useCallback(
    async (exportFormats: ExportFormat[]): Promise<void> => {
      if (!performanceAnalysisParam) {
        return;
      }
      const timePeriod = period.label;
      const periodType = getPeriodicityForMATAndYTD(period, periodicity).periodicity;
      const comparisonTimePeriod = getComparisonPeriod(period, periodType, comparisonPeriod);

      const requestPayload = {
        clientId: retailerClientState.clientId,
        productGroup: appliedProductGroupOptions,
        period: period.value,
        comparisonPeriod: comparisonPeriod,
        periodType: periodicity,
        segment: feature.feature,
      };
      if (view === ViewType.LineChart) {
        const exportLineChartData = cloneDeep(lineChartPerformance);
        try {
          const data: ExportPerformanceBySegmentResp =
            await getExportPerformanceAnalysisLineChart(performanceAnalysisParam);

          const modifiedExportPerformanceBySegmentKpi = modifiedPAORSegmentExportGrandTotalToCamelCaseTotalValue(data);

          //Use to get default Relative Period for Custom months, Rolling Quarter and Calendar Quarter
          //For Custom months, default relative period is Previous Year Current Period
          const relativeComparisonPeriod =
            periodType === Periodicity.CustomMonths
              ? RelativePeriod.PreviousYearCurrentPeriod
              : (comparisonPeriod as RelativePeriod);

          //For custom months, rolling quarter and calendar quarter, default period will be monthly latest period
          const lineChartTimePeriod = getDefaultMonthlyPeriodForPALineChart(periodicity, period, timePeriodOptions);

          //For custom months, rolling quarter and calendar quarter, default periodType will be monthly
          const lineChartPeriodType = convertYTDOrMATtoPeriodType(
            getDefaultValueForDerivablePeriodicity(periodType),
            period.label,
          );

          //For custom months, rolling quarter and calendar quarter, default comparison period will be same period last year
          const lineChartComparisonTimePeriod = getComparisonPeriod(
            lineChartTimePeriod,
            lineChartPeriodType,
            relativeComparisonPeriod,
          );

          const modifiedData = modifiedPAORSegmentExportGrandTotalToCamelCaseTotalValue(exportLineChartData);

          const marketData = processExploreMarketLineChartData(
            modifiedData.kpiDataDto,
            getSaleTypeFromSortingOption(sorting),
          ).filter(Boolean);
          const retailerData = processExploreRetailerLineChartData(
            modifiedData.kpiDataDto,
            getSaleTypeFromSortingOption(sorting),
            transformShareTypeToRetailerKpiOption(selectedShareType),
          ).filter(Boolean);

          const exportImage = [
            exportImages[generateUniqueChartKeys(marketData, ChartKeys[PageType.EXPLORE].MARKET)],
            exportImages[generateUniqueChartKeys(retailerData, ChartKeys[PageType.EXPLORE].RETAILER)],
          ];

          const options: ExportLineChartOptions = {
            exportFormats,
            title: PERFORMANCE_ANALYSIS_CARD_TITLE,
            appliedCountry: appliedCountries,
            appliedPg: appliedProductGroupOptions,
            data: modifiedExportPerformanceBySegmentKpi,
            exportImage,
            timePeriod: lineChartTimePeriod.value,
            comparisonTimePeriod: lineChartComparisonTimePeriod,
            factRevenue: getFactRevenue(pagesConfig, appliedCountries, effectiveProductType),
            periodType: lineChartPeriodType,
            showPerformanceWithin: feature.value,
            appliedFiltersText: getAppliedFiltersText(pagesConfig, PageType.PERFORMANCE_ANALYSIS),
            selectedKpi: matchKPI(pagesConfig.sortingOptions, kpiDropdownOptions(currentVolume)),
            chartTitles: [PERFORMANCE_BY_SEGMENTS_TREND, PERFORMANCE_BY_SEGMENTS_TREND],
            chartSubTitles: getChartSubtitles(
              matchKPI(pagesConfig.sortingOptions, kpiDropdownOptions(currentVolume)).label,
              shareTypeRef.current,
              constructCurrencyLabel(getFactRevenue(pagesConfig, appliedCountries, effectiveProductType)),
            ),
            multipleChartsExport: multipleChartsExport.exportCallbacks,
            pageName: PageName.PERFORMANCE_ANALYSIS,
            volume: currentVolume,
          };

          await exportLineChart(options);

          handleExportedTracking(ElementType.LINE_CHART, exportFormats);
        } catch (err: any) {
          const errorMessage = 'Performance Analysis Board - get export line chart API error.';
          displayExportErrorToastMessage(err, errorMessage, requestPayload, showToastMessage);
          return;
        }
      }
      if (view === ViewType.StackedChart) {
        if (stackedChartRespData.length <= 0 || !performanceAnalysisParam) {
          return;
        }

        const modifiedStackChartKpi = modifiedPAStackChartGrandTotalToTotalValue(stackedChartRespData);

        try {
          await exportStackedChart({
            exportFormats,
            invokeExport,
            title: PERFORMANCE_ANALYSIS_CARD_TITLE,
            appliedCountry: appliedCountries,
            appliedPg: appliedProductGroupOptions,
            data: modifiedStackChartKpi,
            timePeriod,
            comparisonTimePeriod,
            factRevenue: getFactRevenue(pagesConfig, appliedCountries, effectiveProductType),
            periodType,
            showPerformanceWithin: feature.value,
            appliedFiltersText: getAppliedFiltersText(pagesConfig, PageType.PERFORMANCE_ANALYSIS),
            selectedKpi: selectedStackedChartKPI,
            segmentBy: segmentByFeature.label,
            pageName: PageName.PERFORMANCE_ANALYSIS,
            volume: currentVolume,
          });
          handleExportedTracking(
            ElementType.STACKED_CHART,
            exportFormats,
            `${getDisplayNameFromHeaderKey(getStackedChartSortingOptionHeaderKey(), currentVolume)}`,
          );
        } catch (err: any) {
          displayExportErrorToastMessage(
            err,
            'Performance Analysis - exportStackedChart error.',
            requestPayload,
            showToastMessage,
          );
          return;
        }
      }
      if (view === ViewType.Table || view === ViewType.BarChart) {
        await exportTableOrBarChart(
          performanceAnalysisboardPg,
          PERFORMANCE_ANALYSIS_CARD_TITLE,
          exportFormats,
          timePeriod,
          comparisonTimePeriod,
          periodType,
          view,
        );
      }
    },
    [
      performanceAnalysisParam,
      stackedChartRespData,
      view,
      performanceAnalysisboardPg,
      performanceAnalysisboardTotalSize,
      exportImages,
    ],
  );

  const exportTableOrBarChart = async (
    performanceAnalysisboard: PerformanceAnalysisboardPg[],
    title: string,
    exportFormats: ExportFormat[],
    timePeriod: string,
    comparisonTimePeriod: string,
    periodType: string,
    paView: ViewType,
  ) => {
    if (performanceAnalysisboard.length <= 0) {
      return;
    }
    const requestPayload = {
      clientId: retailerClientState.clientId,
      countryIds: queryCountries.map((x) => x.id),
      productGroup: appliedProductGroupOptions,
      period: period.value,
      comparisonPeriod: comparisonPeriod,
      periodType: periodicity,
      shareType: selectedShareType,
      pageRequest: {
        page: defaultPageNumber,
        size: performanceAnalysisboardTotalSize,
      } as PageRequest,
      sortOption: DefaultSortingOptionsForCategoryLeaderboard,
      growthType: selectedGrowthType,
      appliedFilters: allFiltersForPA,
      segment: feature.feature,
      dataType: feature.dataType,
    };
    if (performanceAnalysisboardParam) {
      try {
        const dataForExport: PerformanceAnalysisboardPgPage = await getPerformanceAnalysisBoard(
          performanceAnalysisboardParam,
          {
            page: defaultPageNumber,
            size: performanceAnalysisboardTotalSize,
          } as PageRequest,
        );
        const data: PerformanceAnalysisboardPg[] = modifiedPATableDoubleBarChartGrandTotalToTotalValue(
          dataForExport.content,
        );

        await exportTable({
          exportFormats,
          invokeExport,
          title,
          appliedCountry: appliedCountries,
          appliedPg: appliedProductGroupOptions,
          data,
          timePeriod,
          comparisonTimePeriod,
          factRevenue: factRevenueBySelectedCurrency,
          periodType,
          showPerformanceWithin: feature.value,
          appliedFiltersText: getAppliedFiltersText(pagesConfig, PageType.PERFORMANCE_ANALYSIS),
          selectedKpi: selectedStackedChartKPI,
          pageName: PageName.PERFORMANCE_ANALYSIS,
          volume: currentVolume,
        });
        handleExportedTracking(
          PerformanceAnalysisViewMapping[paView],
          exportFormats,
          ColumnHeaderDisplayNameForCL(currentVolume)[pagesConfig.sortingOptions.headerKey as ColumnHeaderForCL],
          pagesConfig.sortingOptions,
        );
      } catch (err: any) {
        displayExportErrorToastMessage(
          err,
          'Performance Analysis - exportTableOrBarChart error.',
          requestPayload,
          showToastMessage,
        );
        return;
      }
    }
  };

  // Mainly to prevent multiple data api firing.
  const [isFetchingApiLatest, setIsFetchingApiLatest] = useState<boolean>(false);

  /**
   * To handle onChange event of kpi selector, without refreshing the api
   */
  const onKpiSelectHandler = React.useCallback(() => {
    setAreDependenciesUpdated(true);
  }, [allFeatureValuesForPA, segmentByFeature, appliedProductGroupOptions]);

  /**
   * To handle onChange event of feature selector
   */
  const featureHandler = React.useCallback(() => {
    setAreDependenciesUpdated(true);
    setLoadingLineChartData(true);
  }, [allFeatureValuesForPA, segmentByFeature, appliedProductGroupOptions]);

  /**
   * To handle onChange event of segmentBy selector
   * @param bySegmentOption selected option for segmentBy
   */
  const segmentByHandler = (bySegmentOption: FeatureOption) => {
    loadPerformanceAnalysisStackChart(feature, bySegmentOption);
  };

  const apiTriggeringValidator = () => {
    return (
      isValidTimeFrameAndPeriod(periodicity, period) &&
      appliedProductGroupOptions &&
      checkIfCountryExist(selectedCountries, pagesConfig, effectiveProductType) &&
      !isFetchingApiLatest &&
      !onPageFirstLoad &&
      //to not update upon selected filter change
      //pagesConfig.applyFilters for checking if apply button is enabled in filterTray slideout after changing any filter option and not clicking apply.
      (isAppliedFiltersEqualToSelectedFilters(pagesConfig) || pagesConfig.applyFilters) &&
      !pagesConfig.isClearAllFilterTriggered
    );
  };

  const setDataStateToDefault = () => {
    setLineChartPerformance(new ExportPerformanceBySegmentResp());
    setStackedChartRespDataWithSorting([]);
    setPerformanceAnalysisboardPg([]);
    setDoubleBarChartData([]);
    setLoadingTableAndDoubleBarChart(false);
    setLoadingLineChart(false);
    setLoadingStackedChart(false);
    setAreDependenciesUpdated(false);
    setLoadMore(false);
    setTotalPage(defaultTotalPageNumber);
    setIsApiError(false);
  };

  const setPeriodicityNotSubscribedAndReset = () => {
    setDataStateToDefault();
  };
  useEffect(() => {
    const fetchFeatureValues = async () => {
      //To check if feature values not empty, then not required to call PA board, stack chart and line chart API
      if (!isAllFeatureValuesEmpty(allFeatureValuesForPA)) {
        //Prevent multiple calling
        setIsFetchingApiLatest(true);
        const showPerformanceWithinOption = getFeatureSelector(allFeatureValuesForPA, feature);
        setFeature(showPerformanceWithinOption);
        //Table Chart
        loadPerformanceAnalysisTable(showPerformanceWithinOption);
        //Line Chart
        loadPerformanceAnalysisLineChart(showPerformanceWithinOption);

        //Stack Chart
        const handleStackedChartSegmentSelectParams: HandleStackedChartSegmentSelectParams = {
          allFeatureValues: allFeatureValuesForPA,
          selectedPgOptions: selectedProductGroupOptions,
          appliedPgOptions: appliedProductGroupOptions,
          selectedSegmentOption: segmentByFeature,
          setSelectedSegmentOption: setSegmentByFeature,
          showPerformanceWithinOption: showPerformanceWithinOption,
          hasUserClickedApplyAtSideFilters: false,
        };
        const bySegmentSelection = handleStackedChartSegmentSelect(handleStackedChartSegmentSelectParams);
        if (view === ViewType.BarChart || view === ViewType.StackedChart) {
          setLoadingStackedChart(true);
          loadPerformanceAnalysisStackChart(showPerformanceWithinOption, bySegmentSelection);
        }
      } else if (allFeatureValuesForPA.length > 0 && isAllFeatureValuesEmpty(allFeatureValuesForPA)) {
        setDataStateToDefault();
      }
    };
    pagesConfig.setIsCountryChanged(false);
    if (areDependenciesUpdated) {
      fetchFeatureValues();
    }
  }, [areDependenciesUpdated, view]);

  useDebouncedEffect(() => {
    if (!areDependenciesUpdated && apiTriggeringValidator() && !isAllFeatureValuesEmpty(allFeatureValuesForPA)) {
      setAreDependenciesUpdated(true);
    }
    //This is to stop the tables and charts to rerender upon clearing the filters.
    pagesConfig.setIsClearAllFilterTriggered(false);
  }, [
    periodicity,
    period,
    comparisonPeriod,
    pagesConfig.sortingOptions,
    pagesConfig.sortingOptionsPerformanceAnalysisStackedChart,
    selectedGrowthType,
    selectedKpi,
    allFeatureValuesForPA,
  ]);

  /**
   * @remarks
   * useEffect to update current dynamic volume based on period type, default to UNITS
   *
   * **/
  useEffect(() => {
    setCurrentVolume(getVolumeBasedOnPeriodType(filters, periodicity));
  }, [filters, periodicity]);

  const { sortStackedChartRespData } = useStackedChartSorting();

  /**
   * This useEffect is used to update stackedChartRespData order after retrieved response from service
   * Triggered when the Sort By dropdown is changed in the Stacked Chart View in Performance Analysis page
   * Sort By Alphabetical Asc or Desc, and Absolute Asc and Desc
   */
  useEffect(() => {
    setStackedChartRespDataWithSorting(stackedChartRespData);
    pagesConfig.setSortByOptionsPerformanceAnalysisStackedChart(stackedChartSortingOrder);
  }, [stackedChartSortingOrder]);

  const setStackedChartRespDataWithSorting = (data: StackedChartResp[]) => {
    setStackedChartRespData(getSortedStackedChartRespData(data));
  };

  const getSortedStackedChartRespData = (data: StackedChartResp[]): StackedChartResp[] => {
    return sortStackedChartRespData(data, stackedChartSortingOrder, true);
  };

  /**
   * @remarks
   * useEffect for multi country when there is a changes in applied countries/ timeframe picker
   * will need to cross-check if the applied countries exist in the applied period and vice versa
   *
   *
   *
   * if exist then set the warning box to false, else to true
   *
   * dependent on initialFilterState, appliedCountries, periodicity, period
   *
   * **/
  useEffect(() => {
    if (isMultiCountry) {
      const isExist = isSelectedPeriodExistInAllMultiCountries(
        updatedInitialFiltersState,
        period.label,
        periodicity,
        appliedCountries,
      );

      setShowSelectedPeriodNotExistInCountriesWarningBox(!isExist);
    }
  }, [updatedInitialFiltersState, appliedCountries, periodicity, period]);

  useEffect(() => {
    if (countriesToQuery.length === 0) {
      return;
    }

    setQueryCountries(countriesToQuery);
  }, [countriesToQuery]);
  /**
   * packages the main filters, side filters, redux state and selected data view type into the model to be passed to the
   * save view button and copy link button
   */
  const getSaveViewFilters = () => {
    const handledTimeFrame = getPeriodicityForMATAndYTD(period, periodicity);
    const performanceAnalysisViewState: PerformanceAnalysisViewState = {
      periodicity: handledTimeFrame.periodicity,
      matYtdTimePeriodLabel: handledTimeFrame.matYtdLabel,
      comparisonPeriod:
        comparisonPeriod === RelativePeriod.PreviousPeriod || isBaseTimePeriodFormat(comparisonPeriod)
          ? RelativePeriodLabel.PreviousPeriod
          : RelativePeriodLabel.PreviousYearCurrentPeriod,
      growthType: capitalizeFirstLetter(selectedGrowthType),
      appliedFilters: pagesConfig.appliedFilters[PageType.PERFORMANCE_ANALYSIS].selectedFilters,
      retailerClientState: retailerClientState,
      initialFilterState: updatedInitialFiltersState,
      appliedCountries: appliedCountries,
      hitlistRetailerClientState: hitlistsRetailerClientState,
      hitlistInitialFilterState: initialFiltersProductsState,
      productMainFilterState: mainFilterStateProducts,
      dataViewType: view,
      feature: feature,
      selectedShareType: selectedShareType,
      sorting: pagesConfig.sortingOptions,
      sortingStackedChart: pagesConfig.sortingOptionsPerformanceAnalysisStackedChart,
      segmentByFeature: segmentByFeature,
      sortByStackedChart: stackedChartSortingOrder,
    };
    return performanceAnalysisViewState;
  };

  const handleApplyTimeFramePicker = (
    givenPeriodicity: Periodicity,
    givenPeriod: BaseTimePeriod,
    givenComparison: RelativePeriod | BaseTimePeriod,
  ) => {
    setLoadingLineChartData(true);
    applyTimeFramePicker({
      givenPeriod: givenPeriod,
      givenPeriodicity: givenPeriodicity,
      givenComparison: givenComparison,
      pageName: PageName.PERFORMANCE_ANALYSIS,
      pageType: PageType.PERFORMANCE_ANALYSIS,
      pagesConfig: pagesConfig,
      countryChanged: countryChanged,
      sideFiltersState: sideFiltersState,
      retailerClientState: retailerClientState,
      track: track,
      setTimeFrame: periodDispatchActions.updatePeriodicity,
      setPeriod: periodDispatchActions.updatePeriod,
      setRelativePeriod: periodDispatchActions.updateComparisonPeriod,
      setCustomMonthPeriodState: periodDispatchActions.updateCustomMonthsPeriodState,
      setCountryChanged: setCountryChanged,
    });
  };

  const filteredScopeData = getCountryFilterPairsByTimeFrame(pagesConfig.pgsByAppliedCountry, periodicity);

  //Get is monthly or weekly periodicity for all periodicity
  const isMonthlyOrWeekly =
    [Periodicity.Monthly, Periodicity.Weekly].includes(periodicity) && !checkMATOrYTDPeriodicity(period);

  const getSaveViewTrackingObject = () => {
    return {
      access: pagesConfig.access,
      locationId: appliedCountries.map((country) => country.label),
      pageName: PageName.PERFORMANCE_ANALYSIS,
      itemGroup: appliedProductGroupOptions?.map((pg) => pg.label).toString(),
      section: TrackingGeneralProp.SECTION_TRACKING_PROP,
      subSection: PageName.PERFORMANCE_ANALYSIS,
    };
  };

  const getPeriodValueBasedOnChartType = () => {
    return view === PerformanceAnalysisView.LineChart
      ? getDefaultMonthlyPeriodForPALineChart(periodicity, period, timePeriodOptions).value
      : period.value;
  };

  const getLineChartCollectionParams = (): PerformanceAnalysisParam => {
    const kpi = matchKPI(pagesConfig.sortingOptions, kpiDropdownOptions(currentVolume));
    const defaultFeatureSelector = getFeatureSelector(allFeatureValuesForPA, feature);

    return {
      clientId: retailerClientState.clientId,
      productType: effectiveProductType,
      productGroup: appliedProductGroupOptions,
      countries: pagesConfig.clientCountries.filter((x) => appliedCountries.some((y) => x.id === y.value)),
      period: period.value,
      comparisonPeriod: RelativePeriod.PreviousYearCurrentPeriod,
      periodType: periodicity,
      selectedGrowthType: selectedGrowthType,
      saleType: kpi.salesType,
      appliedFilters: allFiltersForPA,
      kpi: kpi.value,
      segment: defaultFeatureSelector.feature,
      dataType: defaultFeatureSelector.dataType,
      isSummary: false,
    };
  };

  useDispatchCountriesAvailability({
    periodValue: getPeriodValueBasedOnChartType(),
    periodicity,
    appliedProductGroups: appliedProductGroupOptions,
    appliedCountries,
    pgsByAppliedCountry: pgsByAppliedCountries,
    masterPgsByCountry: pagesConfig.masterPgsByCountry,
    isWeeklyMatYtdNonLocalCurrency: false,
  });

  useDebouncedEffect(() => {
    const selectedPg = pagesConfig.selectedFilters[PageType.PERFORMANCE_ANALYSIS].selectedFilters.find(
      (f) => f.filterKey === FilterKeys.PRODUCT_GROUP,
    );
    const appliedPg = pagesConfig.appliedFilters[PageType.PERFORMANCE_ANALYSIS].selectedFilters.find(
      (f) => f.filterKey === FilterKeys.PRODUCT_GROUP,
    );
    if (selectedPg === appliedPg) {
      setShowPerformanceFeatureList(allFeatureValuesForPA);
    }
  }, [allFeatureValuesForPA]);

  return (
    <div>
      <Page>
        <Page.Title>
          <PageHeader
            retailerClients={retailerClients}
            onChangeHandler={onChangeHandler}
            productType={effectiveProductType}
          >
            <div className={styles.PerformanceAnalysis__GridContainer}>
              <h1 className={styles.PerformanceAnalysis__Title}>
                <span>Performance Analysis</span>
                <PageInfo
                  title={'Performance Analysis'}
                  content={
                    <section>
                      <p>Get into the detail and understand what who and what is driving the market.</p>
                      <p>
                        Review the factors that matter most to you - whether its seeing how the Brands perform against
                        each other, what Regions are growing in importance, or what feature trends are becoming the next
                        big thing - and visualise them on a range of charts for easy comprehension.
                      </p>
                    </section>
                  }
                />
              </h1>
              {isAuthorizedUser && (
                <div className="flex items-end ml-auto">
                  <PerformanceAnalysisCopyViewButton
                    performanceAnalysisViewState={getSaveViewFilters()}
                    copyViewTracking={getSaveViewTrackingObject()}
                  />
                  <FilterToggleButton onClick={onClick} testId="filter-button" />
                </div>
              )}
            </div>
          </PageHeader>
        </Page.Title>
        <Page.Content>
          <InfoModal />
          {isAuthorizedUser ? (
            <>
              <LoadingOverlay loadingOverlay={loadingOverlay} />
              <div data-test-id="main-filter">
                <div className="flex items-end mt-4">
                  <div className={`${styles.PerformanceAnalysis__Controls} mt-4`}>
                    <TimeFramePickerWrapper
                      currentPeriod={period}
                      currentPeriodicity={periodicity}
                      currentComparison={comparisonPeriod}
                      periodOptions={timePeriodOptions}
                      applyPickerCallback={handleApplyTimeFramePicker}
                      isTimeFramePickerDisabled={isKpiLoading()}
                      isPeriodOptionsDisabled={periodDisabled}
                      disabledPeriodicityOptions={periodDisabled ? disabledPeriodicityLineChart : undefined}
                      customMonthsPeriod={customMonthsPeriodState}
                      appliedCountries={appliedCountries}
                      appliedProductGroups={appliedProductGroupOptions}
                    />
                    <ComparisonGrowthSelector
                      growthOptions={filters?.comparisonGrowth}
                      growthOption={(growthTypes: GrowthTypes) => setGrowthOption(growthTypes)}
                      selectedGrowthOption={selectedGrowthType}
                      isDisabled={false}
                    />
                  </div>
                </div>
                <br />
                <FilterSelectionNote
                  selectedPeriod={period}
                  comparisonPeriodType={comparisonPeriod}
                  selectedPeriodicity={periodicity}
                  scopeMetadata={filteredScopeData[0]?.scopeMetadata}
                />
                <br />
                {isSelectMultiCountry && <CountryAvailabilityBanner />}
                <WarningCurrencyContainer
                  productType={effectiveProductType}
                  periodicity={periodicity}
                  period={period}
                />
                {!isSelectMultiCountry && <PgAvailabilityBanner />}
                <WarningFeatureValueContainer
                  periodicity={periodicity}
                  period={period}
                  pageName={PageName.PERFORMANCE_ANALYSIS}
                />
                <FilterChips pgListByCountry={pagesConfig.pgsByAppliedCountry} selectedTimeFrame={periodicity} />
              </div>
              <br />
              <PerformanceAnalysisCard
                productType={effectiveProductType}
                performanceAnalysisboardPg={performanceAnalysisboardPg}
                doubleBarChartData={doubleBarChartData}
                lineChartData={lineChartPerformance}
                stackedChartRespData={stackedChartRespData}
                selectedGrowthType={selectedGrowthType}
                selectedShareType={selectedShareType}
                setSelectedShareType={setSelectedShareType}
                loadMore={loadMore}
                countries={{
                  dataType: 'COUNTRY',
                  feature: 'COUNTRY',
                  filterTitle: 'Country',
                  filterKey: FilterKeys.COUNTRY,
                  options: [
                    {
                      value: queryCountries[0]?.id,
                      label: queryCountries[0]?.name,
                    },
                  ],
                  disabled: false,
                }}
                selectedPeriodicity={periodicity}
                loadingTableAndDoubleBarChart={loadingTableAndDoubleBarChart || showPgModal}
                loadingLineChart={loadingLineChart}
                loadingStackedChart={loadingStackedChart}
                view={view}
                setView={setView}
                featureFilters={showPerformanceFeatureList}
                // Stacked Bar Chart -> By dropdown
                segmentByFeature={segmentByFeature}
                setSegmentByFeature={setSegmentByFeature}
                segmentByHandler={segmentByHandler}
                // Show performance within and by dropdown options
                feature={feature}
                setFeature={setFeature}
                featureHandler={featureHandler}
                onKpiSelectHandler={onKpiSelectHandler}
                isDisabled={isFetchingApiLatest}
                onChartDownload={onChartDownload}
                onChartExportReady={onChartExportReady}
                onAllChartsExportReady={multipleChartsExport.exportCallbacks}
                factRevenue={getFactRevenue(pagesConfig, appliedCountries, effectiveProductType)}
                factRevenueBySelectedCurrency={factRevenueBySelectedCurrency}
                volume={currentVolume}
                isRestoreFromSavedView={isRestoreFromSavedView}
                setIsRestoreFromSavedView={setIsRestoreFromSavedView}
                isPeriodicityMonthlyOrWeekly={isMonthlyOrWeekly}
                sortByStackedChart={stackedChartSortingOrder}
                setSortByStackedChart={setStackedChartSortingOrder}
                lineChartCollectionsApiParamProps={getLineChartCollectionParams()}
                stackChartCollectionsApiParamProps={getStackChartCollectionParams()}
                pgsByAppliedCountries={pgsByAppliedCountries}
                isApiError={isApiError}
              />
              {showPgModal && (
                <ContextBar
                  setSelectedProductGroup={(paPg: Option) => setSelectedProductGroupOptions([paPg])}
                  setSelectedCountries={setSelectedCountries}
                  isShown={showPgModal}
                  initialFilters={defaultFilters}
                  initialFiltersProducts={initialFiltersProductsState.initialFilters}
                  loadingFeatureValue={loadingFeatureValue}
                  productType={effectiveProductType}
                  productDataType={ProductDataType.PerformanceAnalyzer}
                  setShowPgModal={(isShowPgModal: SetStateAction<boolean>) => setShowPgModal(isShowPgModal)}
                  periodDispatchActions={periodDispatchActions}
                  isMultiCountry={isMultiCountryFeatureFlagEnabled && isMultiCountry}
                  //add this to prevent amplitude race condition
                  setApplyContext={setOnContextBarCompleted}
                />
              )}
            </>
          ) : (
            Unauthorized()
          )}
        </Page.Content>
      </Page>
    </div>
  );
};

const isValidBySelector = (bySelectorOption: FeatureOption): boolean => {
  return bySelectorOption.feature !== '';
};

const isBySelectorOptionInAllFeatureValues = (
  bySelectorOption: FeatureOption,
  allFeatureValues: Filters[],
): boolean => {
  const allFeatureOptions: FeatureOption[] = buildOptions(allFeatureValues);
  return allFeatureOptions.some((featureOption) => featureOption.feature === bySelectorOption.feature);
};

const isShowWithinMatchBySelectorOption = (
  showWithinSelectorOption: FeatureOption,
  bySelectorOption: FeatureOption,
): boolean => {
  return showWithinSelectorOption.value === bySelectorOption.value;
};

const isValidStackedChartCall = ({
  showWithinSelectorOption,
  bySelectorOption,
  periodicity,
  periodSelection,
  allFeatureValues,
  isLoadingStackedChart,
}: {
  showWithinSelectorOption: FeatureOption;
  bySelectorOption: FeatureOption;
  periodicity: Periodicity;
  periodSelection: BaseTimePeriod;
  allFeatureValues: Filters[];
  isLoadingStackedChart: boolean;
}): boolean => {
  return (
    isValidBySelector(bySelectorOption) &&
    isValidTimeFrameAndPeriod(periodicity, periodSelection) &&
    isBySelectorOptionInAllFeatureValues(bySelectorOption, allFeatureValues) &&
    !isLoadingStackedChart &&
    !isShowWithinMatchBySelectorOption(showWithinSelectorOption, bySelectorOption)
  );
};

export const exportTesting = {
  stackedChart: {
    isValidBySelector,
    isValidTimeFrameAndPeriod,
    isBySelectorOptionInAllFeatureValues,
    isShowWithinMatchBySelectorOption,
    isValidStackedChartCall,
  },
};

export default PerformanceAnalysis;
